export const TRAVELER_INFO_TITLE = "Step 1: Add traveler";
export const TRAVELER_INFO_TITLE_UPDATED =
  "Select or add the primary traveler for this reservation.";
export const TRAVELER_INFO_SUBTITLE =
  "Your booking will be reserved under the primary traveler's name.";
export const FREQUENT_FLYER_TITLE = "Frequent flyer details";
export const ADDITIONAL_INFO_TITLE = "Additional information";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const INFANT_SEAT_TITLE = "Infant";
export const INFANT_LAP_TITLE = "Infant";
export const UPDATE_TEXT = "Updating passengers";
export const VALIDATE_TEXT = "Validating passengers";
export const ADD_TRAVELERS_TEXT = "Add primary traveler";
export const ADD_TRAVELERS_TEXT_UPDATED = "Select or add traveler";
export const ADD_TRAVELER_INFO_TEXT = "Add traveler information";
export const TRAVELER_INFO_TEXT = "Add primary traveler";
export const TRAVELER_INFO_REVIEW_TEXT = "Traveler information";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose one traveler to continue.";
